type PrecepteeConfigLike = {
  preceptee_on?: boolean | null;
  preceptee_shift_count?: boolean | null;
} | null;

export type PrecepteePolicy = {
  isPrecepteeFeatureEnabled: boolean;
  includePrecepteeInCount: boolean;
  excludePrecepteeFromCount: boolean;
  excludePrecepteeFromUi: boolean;
};

/**
 * 프리셉티 정책 해석 단일화:
 * - preceptee_shift_count=true  => 합산 포함(Y)
 * - preceptee_shift_count=false => 합산 제외(N)
 */
export function getPrecepteePolicy(
  config?: PrecepteeConfigLike
): PrecepteePolicy {
  const includePrecepteeInCount = Boolean(config?.preceptee_shift_count);
  const excludePrecepteeFromCount = !includePrecepteeInCount;

  return {
    isPrecepteeFeatureEnabled: Boolean(config?.preceptee_on),
    includePrecepteeInCount,
    excludePrecepteeFromCount,
    // 현재 UI 규칙은 합산 정책과 동일하게 적용
    excludePrecepteeFromUi: excludePrecepteeFromCount,
  };
}
